// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestSessionId } from './HarvestSession';
import { harvestId } from './Harvest';
import { harvestAnnotationAnchorKind } from './HarvestAnnotationAnchorKind';
import { harvestOperationId } from './HarvestOperation';
import { harvestSessionKpiId } from './HarvestSessionKpi';
import { brewSampleId } from './BrewSample';
import { harvestAnnotationKind } from './HarvestAnnotationKind';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestAnalysisAnnotationId = (z.number());
export const harvestAnalysisAnnotation = z.object({
    id: harvestAnalysisAnnotationId,
    harvest_session_id: harvestSessionId,
    harvest_id: harvestId.nullable(),
    anchor_kind: harvestAnnotationAnchorKind,
    operation_id: harvestOperationId.nullable(),
    session_kpi_id: harvestSessionKpiId.nullable(),
    sample_id: brewSampleId.nullable(),
    kind: harvestAnnotationKind,
    body: z.string().nullable(),
    show_value: z.boolean(),
    placement: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
});
export const harvestAnalysisAnnotationInitializer = z.object({
    id: harvestAnalysisAnnotationId.optional(),
    harvest_session_id: harvestSessionId,
    harvest_id: harvestId.optional().nullable(),
    anchor_kind: harvestAnnotationAnchorKind,
    operation_id: harvestOperationId.optional().nullable(),
    session_kpi_id: harvestSessionKpiId.optional().nullable(),
    sample_id: brewSampleId.optional().nullable(),
    kind: harvestAnnotationKind.optional(),
    body: z.string().optional().nullable(),
    show_value: z.boolean().optional(),
    placement: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const harvestAnalysisAnnotationMutator = z.object({
    id: harvestAnalysisAnnotationId.optional(),
    harvest_session_id: harvestSessionId.optional(),
    harvest_id: harvestId.optional().nullable(),
    anchor_kind: harvestAnnotationAnchorKind.optional(),
    operation_id: harvestOperationId.optional().nullable(),
    session_kpi_id: harvestSessionKpiId.optional().nullable(),
    sample_id: brewSampleId.optional().nullable(),
    kind: harvestAnnotationKind.optional(),
    body: z.string().optional().nullable(),
    show_value: z.boolean().optional(),
    placement: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestAnalysisAnnotation.js.map